import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=4490c1f6"
import script from "./DashboardMenu.js?vue&type=script&lang=js&external"
export * from "./DashboardMenu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports